// Section components for the RB Restoration Service Agreement.
// Kept small, focused, and reusable across the agreement pages.
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

interface FieldProps {
  label: string;
  value: string;
  onChange: (v: string) => void;
  className?: string;
  type?: string;
  placeholder?: string;
}

export function InlineField({ label, value, onChange, className, type = "text", placeholder }: FieldProps) {
  return (
    <div className={cn("flex items-baseline gap-2 min-w-0", className)}>
      <Label className="text-sm font-semibold text-neutral-700 whitespace-nowrap">{label}</Label>
      <Input
        type={type}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        className="h-8 border-0 border-b border-neutral-400 rounded-none bg-transparent px-1 focus-visible:ring-0 focus-visible:border-primary text-sm print:border-b-black"
      />
    </div>
  );
}

interface CheckProps {
  label: string;
  checked: boolean;
  onChange: (v: boolean) => void;
  className?: string;
}

export function CheckRow({ label, checked, onChange, className }: CheckProps) {
  return (
    <label className={cn("flex items-start gap-2 cursor-pointer text-sm", className)}>
      <Checkbox
        checked={checked}
        onCheckedChange={(v) => onChange(!!v)}
        className="mt-0.5 border-neutral-500"
      />
      <span className="text-neutral-800">{label}</span>
    </label>
  );
}

export function SectionTitle({ children }: { children: React.ReactNode }) {
  return (
    <h2 className="text-lg font-bold text-neutral-900 border-b-2 border-neutral-800 pb-1 mb-3 mt-6 first:mt-0">
      {children}
    </h2>
  );
}

export function PageBreak() {
  return <div className="h-px bg-transparent print:break-after-page my-12" aria-hidden />;
}
